import React, { useState } from "react";

import Modal from "../Modal/Modal";
import Popup from "../Modal/Popup";
import HowUniquePopup from "../Modal/HowUniquePopup";
import { NavLink } from "react-router-dom";
import getBase64Image from "../../../../utils/getBase64Image";

// Import images to be used as default icons
import how_unique_1 from '../../../../icons/how_unique_1.png'
import how_unique_2 from '../../../../icons/how_unique_2.png'
import how_unique_3 from '../../../../icons/how_unique_3.png'
import how_unique_4 from '../../../../icons/how_unique_4.png'
import { usePreview } from "../../../../context/PreviewContextProvider";

// The HowUnique component displays a section of information cards describing unique aspects of NFTs.
const HowUnique = ({ data, campaign }) => {

  // Data structure for each "unique" card, using props for dynamic data or default values if props are missing
  const howUniqueCards = [
    {
      id: 0,
      icon: campaign?.campaign_id && data.imageBuffer.ct_about_icon_1
        ? getBase64Image(data.imageBuffer.ct_about_icon_1, how_unique_1)
        : how_unique_1,
      title: `${campaign?.campaign_id && data.ct_about_title_1 ? data.ct_about_title_1 : "You mint, you decide"}`,
      desc: `${campaign?.campaign_id && data.ct_about_description_1 ? data.ct_about_description_1 : "When you mint—i.e. create a new—NFT, you decide how funds are distributed between the beneficiary, the artist, the sponsor (us), and the seller, each time your newly minted NFT is traded, for its entire life. You can mint an NFT where most of the funds go to the the beneficiary, or you can mint one where most of the funds go to the seller, or to the artist, for instance. It is your choice."}`,
    },
    {
      id: 1,
      icon: campaign?.campaign_id && data.imageBuffer.ct_about_icon_2
        ? getBase64Image(data.imageBuffer.ct_about_icon_2, how_unique_2)
        : how_unique_2,
      title: `${campaign?.campaign_id && data.ct_about_title_2 ? data.ct_about_title_2 : "Rarity, gamified"}`,
      desc: `${campaign?.campaign_id && data.ct_about_description_2 ? data.ct_about_description_2 : "NFTs with a gold background are expensive and legendary. Only five can exist, and there may be even fewer since the entire collection of 300 can mint out completely without any of these being minted. On a budget? Minting becomes a game of strategy. You are in control of the NFT's features, so create one that you think will be especially rare or otherwise cool. Thousands of combinations are possible."}`,
    },
    {
      id: 2,
      icon: campaign?.campaign_id && data.imageBuffer.ct_about_icon_3
        ? getBase64Image(data.imageBuffer.ct_about_icon_3, how_unique_3)
        : how_unique_3,
      title: `${campaign?.campaign_id && data.ct_about_title_3 ? data.ct_about_title_3 : "Support Beneficiary"}`,
      desc: `${campaign?.campaign_id && data.ct_about_description_3 ? data.ct_about_description_3 : "When you buy or sell NFT #AwardNFTs, part of the price paid will go to Fund Raisin’s sponsor for Beneficiary. You can check how much using the pie chart associated with each NFT, and you can also sort your search results accordingly. Funds raised go directly to the recipients’ wallets; there are no intermediaries. Fund Raisin never touches money destined for Beneficiary, the artist, nor the seller."}`,
    },
    {
      id: 3,
      icon: campaign?.campaign_id && data.imageBuffer.ct_about_icon_4
        ? getBase64Image(data.imageBuffer.ct_about_icon_4, how_unique_4)
        : how_unique_4,
      title: `${campaign?.campaign_id && data.ct_about_title_4 ? data.ct_about_title_4 : "Fund Raisin NFTs are green"}`,
      desc: `${campaign?.campaign_id && data.ct_about_description_4 ? data.ct_about_description_4 : "Because Fund Raisin NFTs are minted on the Avalanche platform, it takes a tiny amount of electricity, similar to the amount used to make toast or brew coffee thanks to its novel consensus protocol. Also it's fast! Minting is a quick process that uses only a tiny bit of the Avalanche network’s capacity for less than a second."}`,
    },
  ];

  // State for controlling modal visibility and tracking the selected card
  const [show, setShow] = useState(false);
  const [cardId, setCardId] = useState(0);

  // Function to open the modal and set the ID of the clicked card
  const openModal = (index) => {
    setCardId(index);
    setShow(!show);
  };

  // Function to close the modal by toggling visibility state
  const closeModal = () => {
    setShow(!show);
  };

  return (
    <>
      {/* Anchor link wrapper for navigation */}
      <span className="link_wrapper_about" id="about"></span>

      {/* Main section for HowUnique cards, with a dynamic background gradient */}
      <section
        className="how-unique default-settings gradient-bg"
        style={{
          backgroundImage: `linear-gradient(
            ${data.gradient_color_1},
            ${data.gradient_color_2}
            )`,
          backgroundPosition: "center center"
        }}
      >
        {/* Section title with dynamic color */}
        <h1 className="how-unique__title title-ds" style={{ color: data.light_text_color }}>
          {data.ct_about_main_title ? data.ct_about_main_title : 'How are they unique?'}
        </h1>
        <h1 className="how-unique__title title-mb">How are <br /> they unique?</h1>
        <div className="hr-line"></div>

        {/* Section description */}
        <p className="how-unique__desc" style={{ color: data.light_text_color }}>
          {data.ct_about_main_description ? data.ct_about_main_description : 'The NFTs collection has been created using Fund Raisin in order to help you use NFTs to fund-raise for Beneficiary as core part of his mission.'}
        </p>

        {/* Cards displaying each unique NFT feature */}
        <div className="how-unique__cards">

          {howUniqueCards.map((item) => (
            <div
              key={item.id}
              className="how-unique__card"
              onClick={() => openModal(item.id)}  // Open modal on card click
            >
              <div className="how-unique__card-icon-box">
                <img
                  className="how-unique__card-icon"
                  src={`${item.icon}`}
                  alt="icon"
                />
              </div>
              {/* Card title with dynamic color */}
              <h1 className="how-unique__card-title" style={{ color: data.web_main_color }}>{item.title}</h1>
              <div className="how-unique__card-btn">
                <span className="how-unique__card-btn-text" style={{ color: data.web_main_color }}>Learn More</span>
              </div>
            </div>
          ))}
        </div>

        {/* Link to FAQ section */}
        <NavLink to="/preview-home/faqs" className="faqs-link-wrapper">
          <h3 className="faqs-link">More Answers to Common Questions</h3>
        </NavLink>

        {/* Modal component for displaying more info about each unique feature */}
        <Modal show={show}>
          <Popup>
            <HowUniquePopup
              textColor={data.web_main_color}
              item={howUniqueCards[cardId]}  // Pass selected card data to modal
              onClose={closeModal}  // Close modal on action
            />
          </Popup>
        </Modal>
      </section>
    </>
  );
};

export default HowUnique;
